import { set_snack_bar } from "actions/snackbar/snackbar_action";
import {
  addNewThreadMsg,
  setThreadNotification,
} from "actions/thread/threadAction";
import { toast } from "react-toastify";
import ThreadToast from "../../../../../ThreadToast";

// FIX: Cache recent notifications to prevent duplicates
const recentNotifications = new Map();
const NOTIFICATION_DEDUPE_WINDOW = 2000; // 2 seconds

// Store active desktop notifications for clear all functionality
const activeDesktopNotifications = [];

// Flag to disable notifications (both desktop and toast) after clearing
let notificationsDisabled = false;

// Function to get count of active desktop notifications
export const getActiveDesktopNotificationCount = () => {
  return activeDesktopNotifications.length;
};

// Function to clear all active desktop notifications
export const clearAllDesktopNotifications = () => {
  activeDesktopNotifications.forEach((notification) => {
    try {
      notification.close();
    } catch (error) {
      console.error("Error closing notification:", error);
    }
  });
  // Clear the array
  activeDesktopNotifications.length = 0;
  // Clear all toast notifications
  toast.dismiss();
  // Disable new notifications (they will be re-enabled when a new notification event comes)
  notificationsDisabled = true;
  
  // Re-enable notifications after a short delay (allow new ones to come through)
  setTimeout(() => {
    notificationsDisabled = false;
    
  }, 2000); // 2 seconds delay
};

export const handleThreadEvents = ({
  dispatch,
  socket,
  navigate,
  queryClient,
  isLoggedin,
}) => {
  if (!socket) {
    return;
  }

  // Handle socket connection
  socket.on("connect", () => {});

  socket.on("disconnect", (disconnectData) => {});

  // Handle thread_received_msg event
  socket.on("thread_received_msg", (newMsg) => {
    dispatch(addNewThreadMsg({ newMsg }));
  });

  // handle notification
  const stripHtml = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  socket.on("thread_received_notification", async (newMsg) => {
    const sender = newMsg?.user_details || {};
    const username = sender?.name || "New message";
    const message = newMsg?.messageText || "";
    const type = newMsg?.assesmentData?.type;
    
    // FIX: Create unique key for deduplication
    const notificationKey = `${sender?.user_id}_${newMsg?.assesmentData?._id}_${Math.floor(Date.now() / 1000)}`;

    // Check if we recently showed this notification
    if (recentNotifications.has(notificationKey)) {
      
      return;
    }

    // Mark as shown
    recentNotifications.set(notificationKey, true);
    setTimeout(() => {
      recentNotifications.delete(notificationKey);
    }, NOTIFICATION_DEDUPE_WINDOW);

    await queryClient.invalidateQueries(["esgComplianceAssessmentListTask"]);

    // 🔔 Invalidate notification queries for real-time updates
    await queryClient.invalidateQueries(["notificationsUnreadCount"]);
    await queryClient.invalidateQueries(["notificationsList"]);

    const avatar = sender?.profile_img || null;
    //   if (sender?.specialParam === "PARENT_USER" && type === "SUBMISSION") {
    //   console.log("🚫 Skipping notification for parent user on submission");
    //   return;
    // }
    const shouldSuppressVisualNotification =
      sender?.specialParam === "PARENT_USER" && type === "SUBMISSION";

    const plainMessage = stripHtml(message) || "New Message";

    if (!shouldSuppressVisualNotification && !notificationsDisabled) {
      toast(
        <ThreadToast
          avatar={avatar}
          username={username}
          message={message}
          navigate={navigate}
          dispatch={dispatch}
          redirect={newMsg?.redirect_url}
          rowData={newMsg?.kpiData || newMsg?.assesmentData}
          sender={sender}
          onClose={() => toast.dismiss()}
        />,
        {
          autoClose: false,
          pauseOnHover: true,
          closeOnClick: false,
          icon: false,
        }
      );
    }

    dispatch(setThreadNotification(newMsg));

    // const isTabHidden =
    //   document.hidden || document.visibilityState === "hidden";
    //   console.log("is tab hidden",isTabHidden)

    // if (isTabHidden) document.title = "🔴 New Message";

    // if (isTabHidden && "Notification" in window) {
    //   console.log("inside permisson")
    //   let permission = Notification.permission;

    //   if (permission === "default") {
    //     permission = await Notification.requestPermission();
    //   }

    //   if (permission === "granted") {
    //     console.log("inside notification")
    //     const osNotification = new Notification(username, {
    //       body: plainMessage,
    //       icon: "/logo192.png",
    //     });

    //     osNotification.onclick = () => window.focus();
    //   }
    // }
    let permission = Notification.permission;

    if (permission === "default" && !shouldSuppressVisualNotification) {
      permission = await Notification.requestPermission();
    }

    // Always send notification if permission granted and notifications are not disabled
    if (
      permission === "granted" &&
      !shouldSuppressVisualNotification &&
      !notificationsDisabled
    ) {
      const osNotification = new Notification(username, {
        body: plainMessage,
        icon: avatar || username,
      });

      // Store notification reference for clear all functionality
      activeDesktopNotifications.push(osNotification);

      // Auto-remove from array when notification is closed
      osNotification.onclose = () => {
        const index = activeDesktopNotifications.indexOf(osNotification);
        if (index > -1) {
          activeDesktopNotifications.splice(index, 1);
        }
      };

      // osNotification.onclick = () => window.focus();

      //     osNotification.onclick = () => {
      //   window.focus();

      //   navigate("/task/ESG_Compliance", {
      //     state: {
      //       autoOpenTaskId: newMsg?.assesmentData?.assessment_id,
      //       autoClickMetric: newMsg?.assesmentData?.question_id,
      //       autoClickType: newMsg?.assesmentData?.redirect
      //     },
      //   });
      // };
      osNotification.onclick = () => {
        window.focus();

        const sender = newMsg?.user_details;

        // DataHub KPI_ROLLUP notifications - redirect to Data Sets tab in DataHub module
        // if (sender?.specialParam === "KPI_ROLLUP") {
        //   navigate("/data_hub", {
        //     state: {
        //       dataHubTab: 4, // Data Sets tab index
        //     },
        //   });
        //   return;
        // }

        // DataHub KPI notifications
        // if (
        //   sender?.specialParam?.startsWith("KPI_") ||
        //   sender?.specialParam === "KPI_USER" ||
        //   sender?.specialParam === "KPI_REMINDER"
        // ) {
        //   navigate("/task/Datahub_KPI_Survey", {
        //     state: {
        //       survey_id: newMsg?.kpiData?.survey_id,
        //       assigned_as: newMsg?.kpiData?.assigned_as,
        //       autoOpenSurvey: true,
        //     },
        //   });
        //   return;
        // }

        // // 👉 Same logic as toast
        // if (sender?.specialParam === "TASK_USER") {
        //   navigate("/task/ESG_Compliance", {
        //     state: {
        //       autoOpenTaskId: newMsg?.assesmentData?.assessment_id,
        //       autoClickMetric: newMsg?.assesmentData?.question_id,
        //       autoClickType: newMsg?.assesmentData?.redirect,
        //     },
        //   });
        // } else {
        //   navigate(
        //     `/esg_compliance/${newMsg?.assesmentData?.assessment_name.replaceAll(" ", "_")}`,
        //     {
        //       state: {
        //         autoOpenQuestion: newMsg?.assesmentData?.question_id,
        //         autoClickType: newMsg?.assesmentData?.redirect,
        //         autoClickMetric: newMsg?.assesmentData?.question_id,
        //         assessment_id: newMsg?.assesmentData?.assessment_id,
        //       },
        //     }
        //   );
        // }
        navigate(newMsg?.redirect_url);
      };
    }
  });

  // Handle thread_received_process event
  socket.on("thread_received_process", (newProcess) => {
    dispatch(addNewThreadMsg({ newMsg: newProcess }));
  });

  // Handle rollup_processing event
  socket.on("rollup_processing", (responseJson) => {
    dispatch(
      set_snack_bar(responseJson.status, responseJson.message, "success")
    );
  });
};
